import { ImgHTMLAttributes } from "react";

interface PictureProps extends ImgHTMLAttributes<HTMLImageElement> {
  /** Imported WebP asset (primary source) */
  webp: string;
  /** Imported fallback asset (jpg/png) for older browsers */
  fallback: string;
}

/**
 * Picture: serves WebP to modern browsers, falls back to jpg/png on older ones (e.g. Safari < 14, IE).
 * All other props (alt, className, width, height, loading, etc.) are forwarded to the <img>.
 */
const Picture = ({ webp, fallback, alt = "", ...imgProps }: PictureProps) => (
  <picture>
    <source type="image/webp" srcSet={webp} />
    <img src={fallback} alt={alt} {...imgProps} />
  </picture>
);

export default Picture;
